/* eslint-disable no-undef */
$(() => {
  $.when($.getJSON('/assets/data/hours.json')).done((dataHours) => {

    const allClosed = dataHours[0].all_closed;
    const knownTerms = dataHours[0].known_terms;

    //window['moment-range'].extendMoment(moment);
    dayjs.extend(window.dayjs_plugin_customParseFormat);
    dayjs.extend(window.dayjs_plugin_isBetween);

    // set today's date to memory
    const now = dayjs();
    const nowFormatted = now.format('YYYY-MM-DD');
    const nowWeekday = now.format('dddd');
    const $buildingHours = $('#building-hours');

    // test to see if a given date (now) falls within a range of dates (start_date / end_date
    // of a location's data). Return true if so.
    function hoursInRange(hoursArray) {
      const start = dayjs(hoursArray.start_date, 'YYYY-MM-DD').startOf('day');
      const end = dayjs(hoursArray.end_date, 'YYYY-MM-DD').endOf('day');
      //const range = moment.range(start, end);
      //return range.contains(now);
      const between = now.isBetween(start, end);
      return between;

    }

    // using filter, and the hoursInRange function, find the currently applicable array of
    // hours information & finally, parse them.
    const currentHours = knownTerms.filter(hoursInRange);

    // parse the hours
    function displayHours(allClosed, currentHours) {
      // before looping through larger arrays, check if today is closed for everybody,
      // if so note it and return
      if (allClosed != null) {
        const $allHours = $buildingHours.find('td.hours-info, div.hours-info, span.hours-info');
        const matchesAllClosed = allClosed.filter((day) => {
            const dayMoment = dayjs(day, 'YYYY-MM-DD');
            return dayMoment.isSame(nowFormatted);
          });

        if (matchesAllClosed.length) {
          $allHours.text('closed');
          return;
        }
      }

      // Not all locations closed. set up variables for matching to individual locations & hours
      const { spaces } = currentHours[0];
      for (let i = 0; i < spaces.length; i += 1) {
        const spaceId = spaces[i].space_id;
        const $hoursTextInsert = $(`#${spaceId}-todays-hours`);
        const exceptions = spaces[i].exceptions || [];
        const regularHours = spaces[i].hours;

        // Are there any exceptions listed for this space?
        // If so, filter the dates and return true if matching today's date.
        // Resulting list will be either 1 or 0 length.
        const matchesException = exceptions.filter((exception) => {
          const exceptionMoment = dayjs(exception.date, 'YYYY-MM-DD');
          return exceptionMoment.isSame(nowFormatted);
        });

        // If today's date matches an exception, print the value message to the screen in the
        // appropriate span Otherwise, there are no matching exceptions, print standard
        // weekday/weekend hours for the timespan.
        if (matchesException.length) {
          $hoursTextInsert.text(matchesException[0].value);
        } else {
          $hoursTextInsert.text(regularHours[nowWeekday]);
        }
      }
    }

    if ($buildingHours.length) {
      displayHours(allClosed, currentHours);
    }

    // building Hours Blocks
    const $cardTerms = $('div.weekly-hours').find('div.card');
    const $exceptionDates = $cardTerms.find('li.exceptions');
    const $allClosed = $('ul.all-closed li');



    // Loop through cards of displayed yaml hours
    $cardTerms.each(function () {
      const $this = $(this);
      const startDateMoment = dayjs($this.data('start-term'), 'YYYY-MM-DD').startOf('day');
      const endDateMoment = dayjs($this.data('end-term'), 'YYYY-MM-DD').endOf('day');

      $this.addClass("testing123456");
      // hide hours that have an end date in the past.
      if (endDateMoment.isBefore(now)) {
        $this.hide();
          $("body").addClass("baz");

      }

      // open current hours card
      if (now.isBetween(startDateMoment, endDateMoment)) {
          $("body").addClass("beez");

        $this.find('.collapsed')
          .removeClass('collapsed')
          .end()
          .find('.weekly-hours')
          .addClass('show');
      }
    });

    // hide exceptions occuring in the past
    $exceptionDates.each(function () {
      const $this = $(this);
      const exceptionMoment = dayjs($this.data('exception-date'), 'YYYY-MM-DD');
      const diffInDays = exceptionMoment.diff(nowFormatted, 'days');

      // hide exceptions in the past.
      if (diffInDays < 0) {
        $this.removeClass('in-future').hide();
      }

      // highlight if the closed date is today.
      if (exceptionMoment.isSame(nowFormatted)) {
        $this.append('<span class="float-right badge badge-secondary">today</span>');
      }

      if (diffInDays > 0 && diffInDays <= 7) {
        $this.append('<span class="float-right badge badge-secondary">upcoming</span>');
      }
    });
    const $localExceptions = $('.local-exceptions');

    $localExceptions.each(function () {
      if (!$(this).find('li').hasClass('in-future')) {
        $(this).hide();
      }
    });

    // hide exceptions occuring in the past
    $allClosed.each(function () {
      const $this = $(this);
      const allClosedMoment = dayjs($this.data('closed'), 'YYYY-MM-DD');
      const diffInDays = allClosedMoment.diff(nowFormatted, 'days');

      // highlight if the closed date is today.
      if (allClosedMoment.isSame(nowFormatted)) {
        $this.append(' <span class="float-right badge badge-secondary">today</span>');
      }

      if (diffInDays > 0 && diffInDays <= 7) {
        $this.append(' <span class="float-right badge badge-secondary">upcoming</span>');
      }
    });
  });
});
